export default __webpack_public_path__ + "static/media/D.a5c12d44.wav";